import { render, staticRenderFns } from "./unitsTable.vue?vue&type=template&id=7e39b5cf"
import script from "./unitsTable.vue?vue&type=script&lang=js"
export * from "./unitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports